import classNames from "classnames";

import Markdown from "components/markdown/markdown";
import Tabs from "components/tabs/tabs";
import CommonHero from "components/commonHero/commonHero";

import type { GenericPageData } from "lib/fetchers/genericPage";

import { CookiebotInfo } from "content-ui/cookie-policy/components/CookiebotInfo";

type GenericPageViewProps = Omit<GenericPageData, "seo"> & {};

const GenericPageView = ({ content, pageList, slug }: GenericPageViewProps) => {
  const handleChange = (newValue) => {
    window.location.assign(`/${newValue}`);
  };

  return (
    <main className={"bg-[#F4F4F6] pt-[60px] text-black-rock lg:pt-[69px]"}>
      <div className={"mb-6 md:mb-[52px]"}>
        <CommonHero title={"Legal"} brandColor={"cerise"} />
      </div>
      <section className="max-w-[1140px] md:mx-auto lg:max-w-[1220px]">
        <div className={"mb-[15px] px-5 lg:px-0"}>
          <Tabs active={slug} onChange={handleChange}>
            <Tabs.List
              ariaLabel={"Featured sectors"}
              tabListClassnames={"border-t-0"}
            >
              {pageList.map((tab) => {
                if (!tab.displayTab) return null;
                return (
                  <Tabs.Item
                    component={"link"}
                    href={`/${tab.slug}`}
                    className={"ga-featured-sector-tab"}
                    key={tab.slug}
                    value={tab.slug}
                    noUnderlineAnimation={true}
                  >
                    {tab.title}
                  </Tabs.Item>
                );
              })}
            </Tabs.List>
          </Tabs>
        </div>
        <div className={"flex px-5 lg:px-0"}>
          <div className={"pb-[100px]"}>
            {slug === "cookie-policy" ? <CookiebotInfo /> : null}
            <div
              className={classNames(
                "text-xs md:text-base [&_li]:list-inside [&_li]:list-disc [&_li_ul]:ml-7 [&_ol_li]:list-decimal"
              )}
            >
              <Markdown text={content} />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GenericPageView;
